export const FACTOR_LINKS = {
  smoking_status: '/health-awareness#longterm',
  time_to_first_cigarette: '/quit-benefits#20min',
  cigarettes_per_day: '/health-awareness#lungs',
  quit_attempt_12m: '/quit-benefits#20min',
  stress_control: '/health-awareness#everyday',
  stress_overwhelmed: '/health-awareness#everyday',
  stress_confident: '/health-awareness#quitting',
  stress_going_way: '/health-awareness#quitting',
  mood_interest: '/health-awareness#everyday',
  mood_hopeless: '/health-awareness#everyday',
  alcohol_frequency: '/health-awareness#everyday',
  alcohol_quantity: '/health-awareness#everyday',
  alcohol_binge: '/health-awareness#everyday',
  social_exposure: '/health-awareness#everyday',
  craving_strength: '/quit-benefits#20min',
  routine_trigger: '/health-awareness#everyday',
};

export const DEFAULT_FACTOR_LINK = '/quit-benefits';

export function getFactorLink(questionCode) {
  return FACTOR_LINKS[questionCode] || DEFAULT_FACTOR_LINK;
}
